<style scoped>
.facebook-page-plugin-container {
    overflow: hidden;
    display: flex;
    justify-content: center;
    @apply my-4;
}

/* calc(75rem + 180px * 2) */
@media all and (min-width: 97.5rem) {
    .facebook-page-plugin-container {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        @apply my-0;
    }
}
</style>

<template>
    <div class="facebook-page-plugin-container">
        <iframe
            v-if="show"
            :src="src"
            :width="width"
            :height="height"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';

/*
    Facebook Social Plugin : Page Plugin
    The pixel width of the embed (Min. 180 to Max. 500)
    The pixel height of the embed (Min. 70)
*/

export default {
    props: {
        href: { type: String, default: 'https://www.facebook.com/TryHaLa/' },
        tabs: { type: String, default: 'timeline' },
        useSmallHeader: { type: Boolean, default: true },
        hideCoverPhoto: { type: Boolean, default: false },
        showFriendFaces: { type: Boolean, default: true }
    },
    data() {
        return {
            width: 320,
            height: 500,
            show: false
        };
    },
    computed: {
        src() {
            return encodeURI(
                'https://www.facebook.com/plugins/page.php?' +
                    `href=${this.href}` +
                    `&tabs=${this.tabs}` +
                    `&width=${this.width}` +
                    `&height=${this.height}` +
                    `&small_header=${this.useSmallHeader}` +
                    '&adapt_container_width=true' +
                    `&hide_cover=${this.hideCoverPhoto}` +
                    `&show_facepile=${this.showFriendFaces}` +
                    '&appId'
            );
        }
    },
    methods: {
        calculateWidthAndHeight() {
            if (window.innerWidth <= 500) {
                this.width = Math.max(180, window.innerWidth);
            } else if (window.innerWidth >= 1200 + 180 * 2) {
                this.width = Math.min(
                    500,
                    Math.floor((window.innerWidth - 1200) / 2)
                );
            } else {
                this.width = 500;
            }

            if (window.innerWidth <= 640) {
                // screen sm
                this.height = 70;
            } else if (window.innerWidth >= 1200 + 180 * 2) {
                // const rootScrollHeight = document.documentElement.scrollHeight;
                // const parentEl = this.$el.parentElement;
                // const footerHeight =
                //     rootScrollHeight -
                //     parentEl.scrollHeight -
                //     parentEl.offsetTop;

                // this.height = Math.floor(
                //     window.innerHeight - parentEl.offsetTop - footerHeight
                // );

                // Fixed height
                this.height = 1300;
            } else {
                this.height = 300;
            }
            this.show = true;
        },
        debounceCalculateWidthAndHeight: debounce(function() {
            this.calculateWidthAndHeight();
        }, 500)
    },
    mounted() {
        this._windowInnerWidth = window.innerWidth;
        this._windowInnerHeight = window.innerHeight;
        this.calculateWidthAndHeight();
        this.resize = () => {
            if (
                this._windowInnerWidth !== window.innerWidth ||
                (this._windowInnerWidth !== window.innerWidth &&
                    this._windowInnerHeight !== window.innerHeight)
            ) {
                this.show = false;
                this.debounceCalculateWidthAndHeight();
            }
            this._windowInnerHeight = window.innerHeight;
            this._windowInnerWidth = window.innerWidth;
        };

        window.addEventListener('resize', this.resize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resize);
    }
};
</script>
